import React from 'react'
import styled from 'styled-components/native'
import Card from '@components/Card'
import { colors } from '@lib/colors'

const Wrapper = styled.View`
  margin-top: 10px;
`

const Text = styled.Text`
  font-size: 14px;
  font-style: italic;
  line-height: 18px;
  color: ${colors.gray[500]};
  text-align: center;
`

const NoCompanyNotice: React.VFC = () => {
  return (
    <Wrapper>
      <Card>
        <Text>
          Login to see your work orders
        </Text>
      </Card>
    </Wrapper>
  )
}

export default NoCompanyNotice
